import React, { FC } from 'react';
import { PeriodicBillingListGrid } from './grids';

const PeriodicPrepaidBillingList: FC<{ isSensitiveDataIsShown?: boolean }> = ({ isSensitiveDataIsShown }) => {
  return <PeriodicBillingListGrid isSensitiveDataIsShown={isSensitiveDataIsShown} />;
};

export default PeriodicPrepaidBillingList;
